// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"ada41043","475":"9d25c349"}[chunkId] + ".chunk.js";
};